import { fetchApi } from '@/services/api-client';

export const WEEKLY_MENUS_PATH = '/weekly-menus';

export type BilingualText = {
  en: string;
  th: string;
};

export type DayMenu = {
  dayOfWeek: number; // 0=Monday … 4=Friday
  isHoliday: boolean;
  holidayLabel: BilingualText | null;
  lunch: BilingualText | null;
  afternoonSnack: BilingualText | null;
};

export type WeeklyMenu = {
  id: string;
  weekStart: string; // "YYYY-MM-DD"
  days: DayMenu[];
  published: boolean;
};

export type CreateWeeklyMenuData = {
  weekStart: string;
  days: DayMenu[];
  published?: boolean;
};

export type UpdateWeeklyMenuData = Partial<CreateWeeklyMenuData>;

export const weeklyMenusApi = {
  getAll: () => fetchApi<WeeklyMenu[]>(WEEKLY_MENUS_PATH),
  getById: (id: string) => fetchApi<WeeklyMenu>(`${WEEKLY_MENUS_PATH}/${id}`),
  create: (data: CreateWeeklyMenuData) =>
    fetchApi<WeeklyMenu>(WEEKLY_MENUS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateWeeklyMenuData) =>
    fetchApi<WeeklyMenu>(`${WEEKLY_MENUS_PATH}/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${WEEKLY_MENUS_PATH}/${id}`, { method: 'DELETE' }),
};
